import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

import { CopyFormDialogBase } from '../copy-form-base/copy-form-base.dialog';
import { FormInstance } from '../../models/site-content/form-instance.model';
import { FormInstanceService } from '../../services/form-instance.service';

import { ClipboardService } from '../../services/clipboard.service';
import { FolderService } from '../../services/folder.service';

@Component({
    selector: 'app-copy-form-instance',
    templateUrl: './copy-form-instance.dialog.html',
    styleUrls: [
        '../copy-form-base/copy-form-base.dialog.scss',
        './copy-form-instance.dialog.scss'
    ],
    standalone: false
})
export class CopyFormInstanceDialog extends CopyFormDialogBase implements OnInit {
    // Constructor.
    public constructor(public dialogRef: MatDialogRef<CopyFormInstanceDialog>,
        @Inject(MAT_DIALOG_DATA) public formInstanceToCopy: FormInstance,
        private formInstanceService: FormInstanceService,
        private folderService: FolderService,
        private clipboardService: ClipboardService
    ) {
        super();

        this.formCopyName = this.formInstanceToCopy.name;

        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    public startFormCopy(): void {
        // Copy the form.
        this.copyInProgress = true;

        let toCopy = this.cloneCopiedFormInstance();
        toCopy.name = this.formCopyName;
        this.folderService.copyFormInstances(this.formInstanceToCopy.folderId, [toCopy], false).then(newFormInstances => {
            this.dialogRef.close(newFormInstances);
        });

        return;
    }

    public copyToClipboard(): void {
        let toCopy = this.cloneCopiedFormInstance();
        toCopy.name = this.formCopyName;
        this.clipboardService.copyItemsToClipboard([toCopy])
    }


    // Accessor methods.
    public get SourceFormName(): string {
        return (this.formInstanceToCopy.name);
    }

    private cloneCopiedFormInstance(): FormInstance {
        return Object.assign(new FormInstance(), this.formInstanceToCopy);
    }
}
